import React, { useLayoutEffect, useRef } from 'react';

export default function MotionAnswerPanel({ children }) {
  const slot = useRef(null);
  const panel = useRef(null);
  useLayoutEffect(() => {
    const main = slot.current?.closest('.cr-motion-main');
    if (!main) return undefined;
    const fit = () => {
      const viewport = window.visualViewport;
      const height = viewport?.height || window.innerHeight;
      const bottom = height + (viewport?.offsetTop || 0);
      const documentTop = slot.current.getBoundingClientRect().top + window.scrollY;
      const overflowDocked = window.innerWidth > 760 && window.innerHeight > 500 && height - documentTop - 12 < 260;
      const docked = window.innerWidth <= 760 || window.innerHeight <= 500 || overflowDocked;
      const available = bottom - Math.max(12, slot.current.getBoundingClientRect().top) - 12;
      panel.current.dataset.overflowDocked = String(overflowDocked);
      panel.current.dataset.density = available < 380 ? 'tight' : 'regular';
      main.style.setProperty('--cr-motion-viewport-bottom', `${Math.max(0, window.innerHeight - bottom)}px`);
      const bounds = panel.current.getBoundingClientRect();
      main.style.setProperty('--cr-motion-answer-reserved', docked ? `${bounds.height + 16}px` : '0px');
      panel.current.style.setProperty('--cr-motion-picker-height', `${Math.max(56, (docked ? bounds.top : bounds.bottom) - (viewport?.offsetTop || 0) - 12)}px`);
    };
    let frame = null;
    const scheduleFit = () => {
      if (frame !== null) return;
      frame = window.requestAnimationFrame(() => { frame = null; fit(); });
    };
    fit();
    const observer = window.ResizeObserver ? new window.ResizeObserver(scheduleFit) : null;
    observer?.observe(main);
    observer?.observe(panel.current);
    window.addEventListener('resize', scheduleFit);
    window.addEventListener('scroll', scheduleFit, { passive: true });
    window.visualViewport?.addEventListener('resize', scheduleFit);
    window.visualViewport?.addEventListener('scroll', scheduleFit);
    return () => {
      observer?.disconnect();
      if (frame !== null) window.cancelAnimationFrame(frame);
      window.removeEventListener('resize', scheduleFit);
      window.removeEventListener('scroll', scheduleFit);
      window.visualViewport?.removeEventListener('resize', scheduleFit);
      window.visualViewport?.removeEventListener('scroll', scheduleFit);
      main.style.removeProperty('--cr-motion-answer-reserved');
      main.style.removeProperty('--cr-motion-viewport-bottom');
    };
  }, []);
  return <div className="cr-motion-answer-slot" ref={slot}><div className="cr-answer-panel" ref={panel}>{children}</div></div>;
}
